import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Dashboard from '@/views/Dashboard'
import Metal from '@/views/Metal'

import Login from '@/views/Login'
import Landing from '@/views/Landing'
import Logout from '@/views/Logout'
import MyReports from '@/views/MyReports'
import MyReportsUpdated from '@/views/MyReportsUpdated'
import ReportStatuses from '@/views/ReportStatuses'
import Room from '@/views/Room'
import Profile from '@/views/Profile'
import Help from '@/views/Help'
import Learning from '@/views/Learning'
import News from '@/views/News'
import Handbook from '@/views/Handbook'
import Analytics from '@/views/Analytics'
import SummaryTable from '@/views/SummaryTable'
import TmzSearch from '@/views/TmzSearch'
import TmzSearchKmg from '@/views/TmzSearchKmg'

import PageNotFound from '@/components/PageNotFound'
import NetworkIssue from '@/components/NetworkIssue'
import CreateIlliquidReport from '@/components/tmz/CreateIlliquidReportThree'
import CreateLiquidReportOne from '@/components/tmz/CreateLiquidReportOne'
import CreateLiquidUnclaimedReportTwo from '@/components/tmz/CreateLiquidUnclaimedReportTwo'
import CheckTmzStep from '@/components/tmz/CheckTmzStep'
import CreateIlliquidReportThree from '@/components/tmz/CreateIlliquidReportThree'
import ViewLiquidReportOne from '@/components/tmz/ViewLiquidReportOne'
import ViewLiquidUnclaimedReportTwo from '@/components/tmz/ViewLiquidUnclaimedReportTwo'
import ViewIlliquidReportThree from '@/components/tmz/ViewIlliquidReportThree'
import TmzReports from '@/components/tmz/TmzReports'
import TmzOtherReports from '@/components/tmz/TmzOtherReports'
import FormSix from '@/components/tmz/FormSix'
import LiquidDemandDataDate from '@/components/tmz/LiquidDemandDataDate'
import LiquidUnclaimedDataDate from '@/components/tmz/LiquidUnclaimedDataDate'
import IlliquidDataDate from '@/components/tmz/IlliquidDataDate'
import store from './store'
import LiquidDemandDataPrice from './components/tmz/LiquidDemandDataPrice'
import ErrorTmz from '@/components/tmz/ErrorTmz'

Vue.use(Router)

export const router = new Router({
	mode: 'history',
	base: process.env.VUE_BASE_URL,
	routes: [
		{
			path: '/',
			name: 'landing',
			component: Landing,
			meta: {
				layout: 'landing',
				requiresGuest: true,
			},
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			meta: {
				requiresAuth: true,
				layout: 'dashboard',
			},
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				requiresGuest: true,
				layout: 'landing',
			},
		},
		{
			path: '/logout',
			name: 'logout',
			component: Logout,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/metals',
			name: 'metals',
			component: Metal,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/create-report',
			name: 'create-report',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/CreateTableDropDownTwo'),
		},
		{
			path: '/create-tmz-report',
			name: 'create-tmz-report',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/tmz/CreateIlliquidReportThree'),
		},

		{
			path: '/view-tmz-report/:id',
			name: 'view-tmz-report',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/tmz/IlliquidReportView'),
		},
		{
			path: '/in-reports',
			name: 'in-reports',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./views/MyReports'),
		},
		{
			path: '/reports',
			name: 'reports',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./views/Reports'),
		},
		// {
		//     path: '/finished',
		//     name: 'finished',
		//     meta: {
		//         requiresAuth: true
		//     },
		//     component: () => import('./views/Finished')
		// },
		{
			path: '/notification',
			name: 'notification',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./views/Notification'),
		},
		{
			path: '/view-report/:id',
			name: 'view-report-item',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/ViewTableTwo'),
			beforeEnter(to, from, next) {
				store
					.dispatch('getReport', to.params.id)
					.then(() => {
						next()
					})
					.catch(error => {
						if (
							(error.response && error.response.status == 404) ||
							error.response.status == 403 ||
							error.response.status == 500
						) {
							next({
								name: '404',
								params: { resource: 'отчет' },
							})
						} else {
							next({ name: 'network-issue' })
						}
					})
			},
		},
		{
			path: '/create-report/:id/place',
			name: 'create-report-place',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/CreateMetalPlace'),
		},
		{
			path: '/edit-report/:id/place',
			name: 'edit-report-place',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/EditMetalPlace'),
		},
		{
			path: '/edit-report/:id',
			name: 'edit-report-item',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/EditTableJustTwo'),
		},
		{
			path: '/edit-report-two/:id',
			name: 'force-edit-report-item',
			meta: {
				requiresAuth: true,
			},
			component: () => import('./components/EditTableTwo'),
		},
		{
			path: '/profile',
			name: 'profile',
			component: Profile,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/activateprofile',
			name: 'activate-profile',
			meta: {
				requiresAuth: true,
				isNotActivate: true,
			},
			component: () => import('./views/ActivateUser'),
		},
		{
			path: '/messenger',
			name: 'messenger',
			component: Room,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/room/:roomName',
			name: 'ChatRoom',
			meta: {
				requiresAuth: true,
				isNotActivate: true,
			},
			component: () => import('./views/ChatRoom'),
		},
		{
			path: '/myreports',
			name: 'my-reports',
			component: MyReports,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/myreports-updated',
			name: 'my-reports-updated',
			component: MyReportsUpdated,
			meta: {
				requiresAuth: true,
				layout: 'dashboard',
			},
		},
		{
			path: '/reportstatuses',
			name: 'report-statuses',
			component: ReportStatuses,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/summarytable/',
			name: 'summary-table',
			component: SummaryTable,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tmz-search/',
			name: 'tmz-search',
			component: TmzSearch,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tmz-search-kmg/',
			name: 'tmz-search-kmg',
			component: TmzSearchKmg,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/analytics',
			name: 'analytics',
			component: Analytics,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/handbook',
			name: 'handbook',
			component: Handbook,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/learning',
			name: 'learning',
			component: Learning,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/news',
			name: 'news',
			component: News,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/help',
			name: 'help',
			component: Help,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/check-tmz-step',
			name: 'check-tmz-step',
			component: CheckTmzStep,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tmz-error/:id',
			name: 'tmz-error',
			component: ErrorTmz,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/create-tmz-step-first',
			name: 'create-tmz-step-first',
			component: CreateLiquidReportOne,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-first/:id',
			name: 'view-tmz-step-first',
			component: ViewLiquidReportOne,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-first/:id/date',
			name: 'view-tmz-step-first-date',
			component: LiquidDemandDataDate,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-first/:id/price',
			name: 'view-tmz-step-first-price',
			component: LiquidDemandDataPrice,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-second/:id',
			name: 'view-tmz-step-second',
			component: ViewLiquidUnclaimedReportTwo,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-second/:id/date',
			name: 'view-tmz-step-second-date',
			component: LiquidUnclaimedDataDate,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-third/:id',
			name: 'view-tmz-step-third',
			component: ViewIlliquidReportThree,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-third/:id/date',
			name: 'view-tmz-step-third-date',
			component: IlliquidDataDate,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/view-tmz-step-four/:id',
			name: 'view-tmz-step-four',
			component: FormSix,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/create-tmz-step-second/:tmzId',
			name: 'create-tmz-step-second',
			component: CreateLiquidUnclaimedReportTwo,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/create-tmz-step-third/:tmzId',
			name: 'create-tmz-step-third',
			component: CreateIlliquidReportThree,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tmz-my-reports',
			name: 'tmz-my-reports',
			component: TmzReports,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tmz-other-reports',
			name: 'tmz-other-reports',
			component: TmzOtherReports,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/network-issue',
			component: NetworkIssue,
			name: 'network-issue',
		},
		{
			path: '/404',
			component: PageNotFound,
			name: '404',
			props: true,
		},
		{
			path: '*',
			redirect: { name: '404', params: { resource: 'страница' } },
		},
	],
})
